import { useTranslation } from 'react-i18next'

import {
  DOC_FLOW_PHASE_TITLE_KEYS,
  DOC_FLOW_STATUSES,
} from '../../../constants/docFlow'
import Text from '../../Text'
import { DashboardListRow } from '../DashboardListRow'

import DocFlowIcon from '../../../icons/doc-splitting.svg'

function BirdviewDocFlowRow({ item, onOpen }) {
  const { t } = useTranslation()

  const docFlowStatus = DOC_FLOW_STATUSES[item.status]

  function handleOpen() {
    onOpen(item)
  }

  return (
    <DashboardListRow
      Icon={DocFlowIcon}
      Meta={Text}
      metaProps={{
        children: t(DOC_FLOW_PHASE_TITLE_KEYS[item.phase]),
        isSecondary: true,
      }}
      statusProps={{
        text: t(docFlowStatus.text),
        textColor: docFlowStatus.textColor,
      }}
      title={item.title}
      onAction={handleOpen}
      onOpen={handleOpen}
    />
  )
}

export default BirdviewDocFlowRow
